import {createTheme} from '@mui/material';
import './fonts';

declare module '@mui/material/styles/createPalette' {
  interface PaletteOptions {
    borderColor: string;
    borderColorStrong: string;
    sectionBackground: string;
    deprecatedBackground: string;
    ctaBlack: string;
    ctaDark: string;
  }

  interface Palette {
    borderColor: string;
    borderColorStrong: string;
    sectionBackground: string;
    deprecatedBackground: string;
    ctaBlack: string;
    ctaDark: string;
  }
}

const theme = createTheme({
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    h1: {
      fontSize: '2.25rem'
    },
    h2: {
      fontSize: '2rem',
      fontWeight: 400
    },
    h3: {
      fontSize: '1.75rem'
    },
    h4: {
      fontSize: '1.5rem'
    },
    h5: {
      fontSize: '1.25rem'
    },
    h6: {
      fontSize: '1.25rem'
    }
  },
  palette: {
    primary: {
      main: '#ca0000'
    },
    secondary: {
      main: '#545661'
    },
    background: {
      default: '#f3f3f3'
    },
    grey: {
      50: '#fafafa',
      100: '#f0f0f0',
      200: '#dedede',
      300: '#cccccc',
      400: '#ced4da',
      500: '#9d9d9c',
      600: '#606060'
    },
    borderColor: 'rgba(0,0,0,0.23)',
    borderColorStrong: 'rgba(0,0,0,0.5)',
    sectionBackground: '#f6f6f6',
    deprecatedBackground: '#ffffed',
    ctaBlack: '#001529',
    ctaDark: '#1f1f1f'
  },
  components: {
    MuiRadio: {
      styleOverrides: {
        root: {
          '&.Mui-checked': {
            color: '#1f1f1f'
          }
        }
      }
    },
    MuiButton: {
      styleOverrides: {
        outlinedPrimary: {
          borderColor: '#ca0000'
        }
      }
    },
    MuiFormControlLabel: {
      styleOverrides: {
        label: {
          color: '#1f1f1f'
        }
      }
    }
  }
});

export default theme;
